let dropdown = {
    doc: $(document),
    init: function() {
        let _this = this;
        this.doc
            .on('click', '.dropdown span.dropdown-menu-item', function(e) {
                if (typeof e == 'object' && typeof e.preventDefault == 'function') {
                    e.preventDefault();
                }
                _this.onSelect($(this));
            })
            .on('change', '.dropdown .dropdown-menu-item input[type="checkbox"], .dropdown .dropdown-menu-item input[type="radio"]', function(e) {
                if (typeof e == 'object' && typeof e.preventDefault == 'function') {
                    e.preventDefault();
                }
                _this.onSelect($(this).closest('.dropdown-menu-item'), false);
            });
    },
    onSelect: function(option, markOnSelect = true) {
        if (typeof option == 'object' && option.length) {
            let options = option.siblings('.dropdown-menu-item'),
                selectedOption = options.filter('.dropdown-selected'),
                dropdown = option.closest('.dropdown'),
                isChecked = option.hasClass('dropdown-selected'),
                isMultiple = dropdown.hasClass('dropdown-multiple'),
                dropdownBtn = dropdown.find('.dropdown-btn'),
                dropdownBtnText = dropdownBtn.find('.dropdown-btn-text'),
                optionTextCont = option.find('.dropdown-menu-item-title'),
                optionText = optionTextCont.text().trim(),
                checkedIcon = $('<span>', {
                    class: 'move-right icon-checkbox-mark icon-xs'
                }),
                bTriggerChange = false;

            if (isMultiple) {
                if (isChecked) {
                    option.removeClass('dropdown-selected');
                    optionTextCont.addClass('text-light');
                    if (markOnSelect)
                        option.find('.icon-checkbox-mark, .dropdown-selected-mark').remove();
                }
                else {
                    option.addClass('dropdown-selected');
                    optionTextCont.removeClass('text-light');
                    if (markOnSelect)
                        option.append(checkedIcon);
                }
            }
            else {
                if (selectedOption.length) {
                    selectedOption.removeClass('dropdown-selected');
                    if (markOnSelect) {
                        let mark = selectedOption.find('.icon-checkbox-mark, .dropdown-selected-mark');
                        mark.remove();
                    }
                    if (optionTextCont.hasClass('text-light')) {
                        selectedOption.find('.dropdown-menu-item-title').addClass('text-light');
                    }
                }

                if (!isChecked) {
                    option.addClass('dropdown-selected');
                    if (markOnSelect)
                        option.append(checkedIcon);
                    optionTextCont.removeClass('text-light');

                    if (dropdownBtnText.length && optionText.length) {
                        dropdownBtnText.text(optionText);
                    }

                    bTriggerChange = true;
                }
            }

            if (bTriggerChange) {
                option.trigger('dropdownChange', {
                    wrapper: dropdown,
                    multiple: isMultiple,
                    dropdown_btn: dropdownBtn,
                    item: option,
                    prev: selectedOption,
                });
            }
        }
    }
};